export default "__VITE_ASSET__be973073__"